import { isArray, propAccessor } from '@hc-frontend/utils'

function getPolicy({ plan, duration = null, policies = null }) {
  let usedDuration
  let usedPolicies
  let policy

  if (isArray(plan.durations)) {
    policy = plan.durations[0] // For multi-carrier plans, we assume policy is 1
    usedDuration = policy.policyDuration
    usedPolicies = 1
  } else {
    usedDuration = duration || Math.min(...Object.keys(plan.durations).map(d => +d))
    usedPolicies =
      policies || Math.min(...Object.keys(plan.durations[usedDuration]).map(d => +d))

    policy = propAccessor(plan.durations, [usedDuration, usedPolicies])
    if (!policy)
      throw new Error(
        `Policy not found for duration planId: ${plan.planId} duration: ${usedDuration} and policies: ${usedPolicies}`
      )
  }

  return {
    duration: usedDuration,
    policies: usedPolicies,
    policy
  }
}

export default getPolicy
